@use "../../sass/variables/colors";
@use "../../sass/variables/typography";
@use "../../sass/mixins/font-family";

:host {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.top-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.step {
  font-size: typography.$size-text-small;
}

.step-bold {
  @include font-family.font(bold);
}

.bar {
  position: relative;
  flex-grow: 1;
  height: 8px;
  background-color: colors.$color-black-5;
  border-radius: 4px;
  overflow: hidden;
  width: 100%;
}

.fill {
  height: 100%;
  border-radius: 4px;
  background-color: colors.$color-green-100;
  transition: width 0.3s ease-in-out;

  @container style(--trumpf-ux-animations: disabled) {
    transition: none !important;
  }
}